import { Box, Flex, Heading, RadioCards } from '@radix-ui/themes';
import { BuildPriorityCallout } from 'components/common/build-priority-callout';
import { ErrorBoundary } from 'components/common/error-boundary';
import { PDBreaksModeForm } from 'components/sections/pitch-design/input-mode/breaks';
import { PDDefaultModeForm } from 'components/sections/pitch-design/input-mode/default';
import { PDSpinsModeForm } from 'components/sections/pitch-design/input-mode/spins';
import { CookieKey } from 'enums/cookies.enums';
import { t } from 'i18next';
import { BuildPriority } from 'lib_ts/enums/pitches.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { FC } from 'react';
import { useCookiesStore } from 'stores/use-cookies-store';
import { usePitchDesignStore } from 'stores/use-pitch-design-store';

export const InputModeForm: FC = () => {
  const showCurrent = usePitchDesignStore((s) => s.showCurrent);
  const refPitch = usePitchDesignStore((s) => s.refPitch);
  const priority = usePitchDesignStore((s) => s.priority);

  return (
    <ErrorBoundary identifier="PDMainForm">
      <Flex direction="column" gap={RADIX.FLEX.GAP.FORM}>
        <Heading size={RADIX.HEADING.SIZE.SM}>{t('pd.input-mode')}</Heading>
        <RadioCards.Root
          size="1"
          gap={RADIX.FLEX.GAP.SM}
          value={priority}
          onValueChange={(v) => {
            usePitchDesignStore.getState().setPriority(v as BuildPriority);

            useCookiesStore.getState().setCookie(CookieKey.app, {
              build_priority: v as BuildPriority,
            });
          }}
        >
          {Object.values(BuildPriority).map((v, i) => {
            const isDefault = showCurrent && v === refPitch.priority;

            return (
              <RadioCards.Item key={`priority-${i}`} value={v}>
                {t(v)} {isDefault ? '*' : ''}
              </RadioCards.Item>
            );
          })}
        </RadioCards.Root>

        <Box>
          <BuildPriorityCallout priority={priority} />
        </Box>

        {priority === BuildPriority.Default && <PDDefaultModeForm />}
        {priority === BuildPriority.Spins && <PDSpinsModeForm />}
        {priority === BuildPriority.Breaks && <PDBreaksModeForm />}
      </Flex>
    </ErrorBoundary>
  );
};
